import {gql} from "graphql-request";

export const GetAllHikeTags = gql`
  query GetAllHikeTags {
    allHikeTags {
      activityTags
      featureTags
    }
  }
`
